/** Where a pasted application link should go, as an in-app path, or null if it isn't one.
 *  Accepts the whole link (any host, with or without https://, even inside other text) or just the code from the end of it.
 *  Codes are told apart by length: applications 22, property apply keys 16, Request info links 24 (see server.py token_urlsafe). */
const PATH = /\/(a|apply|fix|criteria)\/([A-Za-z0-9_-]{10,64})(?:\/([a-z][a-z0-9_]*))?/;
const CODE = /^[A-Za-z0-9_-]+$/;
const BY_LENGTH = { 22: "a", 16: "apply", 24: "fix" };

export const parseApplicationLink = (raw) => {
  const text = (raw || "").trim();
  if (!text) return null;
  const m = text.match(PATH);
  if (m) return `/${m[1]}/${m[2]}${m[1] === "a" && m[3] ? `/${m[3]}` : ""}`;
  const kind = CODE.test(text) && BY_LENGTH[text.length];
  return kind ? `/${kind}/${text}` : null;
};
